import React, { useEffect, useState } from "react";
import { createPanelVote, getPollsByPanel } from "app/apis/panels";
import { useAppContext } from "app/contexts/AppContext";
import EmployeeProfile from "app/views/common_component/EmployeeProfile";
import { useTranslation } from "react-i18next";

const PublishedPoll = () => {
    const { selectedPanel } = useAppContext()
    const [polls, setPolls] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedChoices, setSelectedChoices] = useState({});
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [currentVote, setCurrentVote] = useState({ pollIndex: null, choice: null });
    const employee_id = sessionStorage.getItem("employee_id");
    const [change, setChange] = useState(false)
    const { t } = useTranslation();

    useEffect(() => {
        if (!selectedPanel?.uu_id) return;
        const fetchPollsForPanels = async () => {
            try {
                const response = await getPollsByPanel(selectedPanel.uu_id);
                setPolls(response?.data || []);
            } catch (error) {
                setError(error.message);
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPollsForPanels();
    }, [selectedPanel?.uu_id, change]);

    const handleVote = (pollIndex, choice) => {
        if (!employee_id) {
            alert("Please log in to vote.");
            return;
        }
        setCurrentVote({ pollIndex, choice });
        setShowConfirmation(true);
    };

    const confirmVote = async () => {
        const { pollIndex, choice } = currentVote;
        const poll = polls[pollIndex];

        const voteData = new FormData();
        voteData.append("voted_by", employee_id);
        voteData.append("poll", poll.uu_id);
        voteData.append("choice", choice.uu_id);

        try {
            await createPanelVote(voteData);
            setChange(!change)
            setSelectedChoices((prev) => ({
                ...prev,
                [pollIndex]: choice.uu_id,
            }));
        } catch (error) {
            console.error("Voting failed:", error);
            alert("Failed to submit vote.");
        } finally {
            setShowConfirmation(false);
        }
    };

    const cancelVote = () => {
        setShowConfirmation(false);
    };

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div className="text-red-500">Error: {error}</div>;
    if (polls.length === 0) {
        return (
            <div className="flex items-center justify-center p-4">
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    {/* <h2 className="text-xl font-semibold mb-2">No Polls Available</h2> */}
                    <h2 className="text-xl font-semibold mb-2">{t('No Polls Available')}</h2>
                    {/* <p className="text-gray-600">There are no polls available for this panel.</p> */}
                    <p className="text-gray-600">{t('There are no polls available for this panel.')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {polls.map((poll, pollIndex) => (
                <div style={{ padding: 5 }}>
                    <div key={poll.uu_id} className="space-y-4">
                        <EmployeeProfile request={poll?.created_by} />

                        <h3 className="text-[22] font-semibold flex items-center space-x-2">
                            <img src={`${process.env.PUBLIC_URL}/assets/polls.svg`} alt="Polls Icon" className="w-6 h-6" />
                            {/* <span style={{ color: "#AAAAAA" }}>Polls</span> */}
                            <span style={{ color: "#AAAAAA" }}>{t('Polls')}</span>
                        </h3>

                        <p className="text-[22] font-medium text-black">{poll.question}</p>

                        <div className="grid grid-cols-2 gap-4">
                            {poll.choices.map((choice) => {
                                // Count the number of votes for this choice
                                const voteCount = poll.votes.filter(
                                    (vote) => vote.choice.uu_id === choice.uu_id
                                ).length;

                                return (
                                    <div
                                        key={choice.uu_id}
                                        className={`border p-4 rounded-lg shadow-sm cursor-pointer bg-white ${selectedChoices[pollIndex] === choice.uu_id ? "border-black-500" : ""} ${selectedPanel.closed ? "pointer-events-none opacity-50" : ""}`}
                                        onClick={() => !selectedPanel.closed && handleVote(pollIndex, choice)}
                                        role="button"
                                        tabIndex={0}
                                        onKeyPress={(e) => e.key === 'Enter' && !selectedPanel.closed && handleVote(pollIndex, choice)}
                                    >

                                        <div className="flex items-center">
                                            <div
                                                className={`w-6 h-6 rounded-full border-4 border-black flex items-center justify-center cursor-pointer ${selectedChoices[pollIndex] === choice.uu_id ? "bg-black" : "bg-white"
                                                    }`}
                                                onClick={() => handleVote(pollIndex, choice)}
                                            >
                                                {selectedChoices[pollIndex] === choice.uu_id && (
                                                    <div className="w-4 h-4 bg-white rounded-full"></div>
                                                )}
                                            </div>
                                            <div className="ml-3">
                                                <span className="text-[22] font-semibold block">{choice.text}</span>
                                                {/* <span className="text-gray-500 text-[20]">{voteCount} Voted</span> */}
                                                <span className="text-gray-500 text-[20]">{voteCount} {t('Voted')}</span>
                                            </div>
                                        </div>


                                        {/* Display voters' names (if available) */}
                                        <div className="mt-3 space-y-2">
                                            {poll.votes
                                                .filter((vote) => vote.choice.uu_id === choice.uu_id)
                                                .map((vote) => (
                                                    <div key={vote.uu_id} className="flex flex-col items-center p-2 rounded-lg">
                                                        <div className="flex-1 w-full">
                                                            <EmployeeProfile request={vote?.voted_by} />
                                                        </div>
                                                        <hr style={{ width: "100%", borderTop: "1px solid #E8E8E8", margin: "8px 0" }} />
                                                    </div>
                                                ))}
                                        </div>

                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            ))}

            {showConfirmation && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center" style={{ zIndex: 4000 }}>
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        {/* <p className="text-[22] font-semibold mb-4">Are you sure you want to vote for this option?</p> */}
                        <p className="text-[22] font-semibold mb-4">{t('Are you sure you want to vote for this option?')}</p>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={cancelVote}
                                className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
                            >
                                {/* Cancel */}
                                {t('Cancel')}
                            </button>
                            <button
                                onClick={confirmVote}
                                className="px-4 py-2 bg-[#DCBD7F] text-black rounded-lg hover:bg-[#DCBD7F]"
                            >
                                {/* Confirm */}
                                {t('Confirm')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PublishedPoll;